// extracted by mini-css-extract-plugin
export default {"form":"FormLayout_form__Pbx5X","row":"FormLayout_row__halLc","col":"FormLayout_col__urcsj"};